// Canonical store links for driving website CTAs to the native apps.
export const APP_STORE_URL = "https://apps.apple.com/app/pagent/id6670614673";
export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.pagent";

/** Pick App Store vs Play Store from the current user agent. Desktop defaults to App Store. */
export function getStoreUrl() {
  const ua = typeof navigator !== "undefined" ? navigator.userAgent || "" : "";
  if (/android/i.test(ua)) return PLAY_STORE_URL;
  return APP_STORE_URL;
}

export function openAppStore() {
  window.open(getStoreUrl(), "_blank", "noopener,noreferrer");
}
